var practice_details = (function( $ ) {

	var $wrap;

	var _init = function() {
		$wrap = $( '#account-page' ).find( '.practice-details' );

		if ( $wrap.length > 0 ) {
			// $wrap.find( 'a.update' ).on( 'click', _show_form );
		}
	};

	var _show_form = function( e ) {
		e.preventDefault();

		$( '.current-practice' ).slideUp();
		$( '#practice_details_form' ).slideDown();
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = practice_details;